import { MetadataFields } from './types';

export const DEFAULT_METADATA_PICKER_REQUEST_FIELDS: MetadataFields = ['id', 'name', 'parent', 'sortOrder'];
export const DEFAULT_SCOPE = 'metadata-picker';
export const DEFAULT_SCOPE_MULTIPLE = 'metadata-picker-multiple';
